module.exports = __webpack_public_path__ + "d1f63e2214869b60813f5dc2181f5ebf.svg";